import { components, SingleValueProps } from 'react-select';
import { timezoneToAbbrString } from '../utils/date';
import { TimeZoneOption } from './types';

const SingleValue = (props: SingleValueProps<TimeZoneOption>) => {
    const tzData: TimeZoneOption = props.data;
    const zoneOffset = timezoneToAbbrString(tzData.value);
    const labelText = tzData ? `${tzData?.alternativeName} (${zoneOffset})` : '...';
    return <components.SingleValue {...props}>{labelText}</components.SingleValue>;
};

export default SingleValue;
